import * as React from "react";

function LinkSlashIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    role: "img",
    fill: "currentColor",
    className: "anticon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M185.7 120.2c56.4-44.64 138.6-40.89 190.8 11.3 43.3 43.3 52.6 107.9 29.2 161.2l45.6 35.7 95.1-95.1c37.4-37.5 37.4-98.2 0-135.59-35.7-35.69-93-37.6-130.9-4.36l-6.2 5.35c-9.9 8.7-25.1 7.7-33.8-2.26-8.8-9.97-7.7-25.13 2.2-33.86l6.2-5.36c57-49.869 142.9-47.01 196.4 6.55 56.2 56.13 56.2 147.23 0 203.43l-91 91 141.5 110.9c10.4 8.2 12.3 23.3 4.1 33.7-8.2 10.4-23.3 12.3-33.7 4.1L9.196 42.89C-1.236 34.71-3.065 19.63 5.112 9.196 13.29-1.236 28.37-3.065 38.81 5.112L185.7 120.2zm39.4 30.9 141.2 110.7c10.3-33.1 2.2-70.4-23.8-96.4-31.8-31.9-81.4-36.6-117.4-14.3zm38.4 229.4c-30.1-30-44.2-70.3-41.9-109.9l54.2 42.7c4.6 12.1 11.9 23.5 21.6 33.3 14.7 15.5 35.1 24.6 55.2 27.2l54.3 42.8c-49.1 14.7-104.6 2.7-143.4-36.1zM116.6 187.9l38 29.9-60.97 60.9c-37.44 37.5-37.44 98.2 0 135.6 35.67 34.8 92.97 37.6 130.87 4.4l6.2-5.4c9.9-8.7 25.1-7.7 33.8 2.3 8.7 9.9 7.7 25.1-2.2 33.8l-6.2 5.4c-57 49.9-142.9 47-196.41-6.6-56.185-56.1-56.185-148.1 0-203.4l56.91-56.9z"
  }));
}

const ForwardRef = React.forwardRef(LinkSlashIcon);
export default ForwardRef;